import { useEffect } from 'react';
import { RewardProgramIntegrationData } from 'types/rewardProgramIntegration';
import useHyattAuth from './useHyattAuth';

interface UseMemberInfoProps {
  onSuccess?: (memberInfo: RewardProgramIntegrationData) => void;
  onError?: (error: unknown) => void;
}

const useFetchMemberInfo = (props: UseMemberInfoProps) => {
  const { getMemberInfo, verifySession, getAccessToken } = useHyattAuth();

  useEffect(() => {
    const isSessionAcive = verifySession();
    if (!isSessionAcive) return;
    const token = getAccessToken();
    if (!token) return;
    const fetchData = async () => {
      try {
        const memberData = await getMemberInfo(token);
        props?.onSuccess?.(memberData);
      } catch (error) {
        props?.onError?.(error);
      }
    };
    fetchData();
  }, []);
};

export default useFetchMemberInfo;
